// extracted by mini-css-extract-plugin
module.exports = {"popupBg":"Popup_popupBg__JvfSU","popup":"Popup_popup__1ZVU3"};